import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { Link } from "react-router-dom";
import { deepOrange, green } from "@material-ui/core/colors";
import Grid from "@material-ui/core/Grid";

import LogoutButton from "../components/LogoutButton";

const useStyles = makeStyles((theme) => ({
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  root: {
    flexGrow: 1,
    display: "flex",
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  square: {
    color: theme.palette.getContrastText(deepOrange[500]),
    backgroundColor: deepOrange[500],
  },
  rounded: {
    color: "#fff",
    backgroundColor: green[500],
  },
}));

export default function NavBar() {
  const classes = useStyles();

  const [isLogged, setIsLogged] = useState();

  useEffect(() => {
    const interval = setInterval(() => {
      if (localStorage.getItem("user") !== "null") {
        setIsLogged(true);
      } else {
        setIsLogged(false);
      }
    }, 500);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className={classes.root}>
      <AppBar position="static" style={{ borderRadius: 20 }}>
        <Toolbar>
          <Typography variant="h3" className={classes.title}>
            Distant Medicus
          </Typography>
          {isLogged ? (
            <LogoutButton />
          ) : (
            <Grid style={{ display: "flex", flexDirection: "row" }}>
              <Link
                style={{ color: "white", textDecoration: "none" }}
                to="/login"
              >
                {" "}
                  <h2>LOGIN</h2>
              </Link>
              <Link
                style={{
                  color: "white",
                  textDecoration: "none",
                  paddingLeft: 10,
                }}
                to="/signup"
              >
                  <h2>SIGN UP</h2>
              </Link>
            </Grid>
          )}
        </Toolbar>
      </AppBar>
    </div>
  );
}

// export default NavBar
